@use '../../styling/colors.scss' as *;

.EnabledIndicator {
  &.Enabled {
    color: $color-secondary-green;
  }

  &.Disabled {
    color: $color-warning-orange;
  }
}
